"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonList = void 0;

var _makeClassNameComponent = _interopRequireDefault(require("../utils/makeClassNameComponent"));

var _ui = _interopRequireDefault(require("./ui.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ButtonList = (0, _makeClassNameComponent.default)(_ui.default.list);
exports.ButtonList = ButtonList;